export default __webpack_public_path__ + "static/media/ban-solid.b51c6bf4.svg";